const indexToNameMap = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const mapMonthIndexToName = (index) => indexToNameMap[index];
